
 <div mobile (mobileView)="isMobileView = $event">
  <ng-template [ngIf]="!isMobileView">
    <div  class="articles-container row"> 
      <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
        <div class="articles-left-content">
          <h4>
            <span *ngIf="isFeature">Focus </span>{{category}}
          </h4>
        
          <ng-template ngFor let-article [ngForOf]="articles">
            <div
              class="catalog-list-item catalog-list-item--clickable"
              (click)="selectedArticle = article"
              [ngClass]="{
                'catalog-list-item--selected': selectedArticle.id == article.id
              }" >
              {{ article?.title }}
            </div>
          </ng-template>
        </div>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
        <div *ngIf="selectedArticle" class="articles-right-content">
          <h1>
            {{ selectedArticle?.title}}
          </h1>
          <div class="article-history align-h margin-top-35 margin-bottom-35">
            <div class="article-history-updated stretch">{{selectedArticle?.month }}, {{selectedArticle?.year }}</div>
        
              <div class="article-history-sharing">
                Share article to
                <a href="https://twitter.com/share?url={{ pageUrl }}" target="_blank">
                  <img src="assets/images/twitter-logo-blue.png" alt="twitter" />
                </a>
                <a
                  href="https://www.facebook.com/sharer/sharer.php?u={{ pageUrl }}"
                  target="_blank"
                >
                  <img src="assets/images/facebook-icon.png" alt="facebook" />
                </a>
                
                <a
                  href="https://www.linkedin.com/shareArticle?url={{ pageUrl }}"
                  target="_blank"
                >
                  <img src="assets/images/linkedin.png" alt="linkedin" />
                </a>
              </div>
              <button
              *ngIf="selectedArticle['pdfUrl'] && !inProgress"
                type="button"
                class="btn btn-primary btn-lg pdf-button"
                (click)="downloadAsPDF(selectedArticle['pdfUrl'])"
              >
                <span class="article-history-pdf-download">
                  <img src="assets/svg/pdf-file.svg" alt="pdf" />
                </span>
                Download
              </button>
              <mat-spinner *ngIf="inProgress"  [diameter]="25"></mat-spinner>
          </div>
          <div
            class="article-image"
            *ngIf="selectedArticle['imagePath']"
          >
            <img
              [src]="selectedArticle['imagePath']"
              [alt]="selectedArticle['title']"
            />
          </div>
          <div
            class="article-image"
            *ngIf="selectedArticle['video']"
          >
            <iframe class="article-vedio-iframe" [src]="getSafeUrl(selectedArticle['video'])" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
            </iframe>
          </div>
          <div class="article-html-content margin-top-35 margin-bottom-35">
            <p [innerHTML]="selectedArticle['htmlContent']"></p>
            <a *ngIf="selectedArticle['pdfUrl']" [href]="selectedArticle['pdfUrl']" target="_blank">View</a>
          </div>
            <div class="button-black">
            <button type="button" class="btn btn-primary btn-lg" (click)="investOnline()">Invest Now</button>
          </div>
        </div>

      </div>
    </div>
  </ng-template>
  <ng-template [ngIf]="isMobileView">
      <app-article-details-mobile></app-article-details-mobile>
  </ng-template>
</div>
